import React from "react";
import { connect } from "react-redux";
import BookingToast from "../../../containers/BookingToast";
import "./notificationbar.scss";
import { Howl } from "howler";
import { toast } from "react-toastify";
import pusher from "../../../pusherConfig";

// const bookingToaster = (data, eventType, history) => {
//   try {
//     let soundSrc;
//     let toastType;
//     let toastMessage;
//     let autoClose = false;

//     if (eventType === "booking-create") {
//       soundSrc = [require("../assets/audios/booking-confirmation.mp3")];
//       toastType = "success";
//       toastMessage = data.message;
//       autoClose = true;
//     } else if (eventType === "booking-cancel") {
//       soundSrc = [require("../assets/audios/booking-cancel.mp3")];
//       toastType = "warning";
//       toastMessage = data.message;
//       autoClose = true;
//     } else if (eventType === "enquiries") {
//       soundSrc = [require("../assets/audios/customer-enquiry.mp3")];
//       toastType = "info";
//       toastMessage = <BookingToast {...data} history={history} />;
//     } else if (eventType === "booking-create-customer") {
//       soundSrc = [require("../assets/audios/booking-confirmation.mp3")];
//       toastType = "success";
//       toastMessage = <BookingToast {...data} history={history} />;
//     } else if (eventType === "booking-cancel-customer") {
//       soundSrc = [require("../assets/audios/customer-cancel.mp3")];
//       toastType = "warning";
//       toastMessage = <BookingToast {...data} history={history} />;
//     }

//     const successSound = new Howl({
//       src: soundSrc,
//       autoplay: true,
//     });
//     successSound.play();
//     console.log({ asasasas: data });

//     // Display toast using custom function
//     toast(toastMessage, {
//       type: toastType,
//       autoClose,
//     });
//   } catch (error) {
//     console.error("Error playing audio or displaying toast:", error);
//   }
// };

class NotificationBar extends React.Component {
  // componentDidMount() {
  //   const storedData = localStorage.getItem("bookingData");
  //   const storedCancelData = localStorage.getItem("bookingCancelData");
  //   const storedEnquiryData = localStorage.getItem("bookingEnquiryData");
  //   const storedCustomerData = localStorage.getItem("bookingCustomerData");
  //   const storedCustomerCancelData = localStorage.getItem(
  //     "bookingCustomerCancelData"
  //   );
  //   if (storedData) {
  //     // Delay the execution of eventHandler by 3 seconds
  //     setTimeout(() => {
  //       this.eventHandler(JSON.parse(storedData), "booking-create");
  //       // Clear the stored data after handling
  //       localStorage.removeItem("bookingData");
  //     }, 3000);
  //   }

  //   if (storedCancelData) {
  //     setTimeout(() => {
  //       this.eventHandler(JSON.parse(storedCancelData), "booking-cancel");
  //       localStorage.removeItem("bookingCancelData");
  //     }, 3000);
  //   }
  //   if (storedEnquiryData) {
  //     setTimeout(() => {
  //       this.eventHandler(JSON.parse(storedEnquiryData), "enquiries");
  //       localStorage.removeItem("bookingEnquiryData");
  //     }, 3000);
  //   }
  //   if (storedCustomerData) {
  //     setTimeout(() => {
  //       this.eventHandler(
  //         JSON.parse(storedCustomerData),
  //         "booking-create-customer"
  //       );
  //       localStorage.removeItem("bookingCustomerData");
  //     }, 3000);
  //   }
  //   if (storedCustomerCancelData) {
  //     setTimeout(() => {
  //       this.eventHandler(
  //         JSON.parse(storedCustomerCancelData),
  //         "booking-cancel-customer"
  //       );
  //       localStorage.removeItem("bookingCustomerCancelData");
  //     }, 3000);
  //   }

  //   this.props.isLoggedIn();

  //   this.channel = pusher.subscribe("taxida-bookings");
  //   this.channel.bind("booking-create", this.handleBookingCreate, this);
  //   this.channel.bind("booking-cancel", this.handleBookingCancel, this);
  //   this.channel.bind("enquiries", this.handleBookingEnquiry, this);
  //   this.channel.bind(
  //     "booking-create-customer",
  //     this.handleCustomerCreate,
  //     this
  //   );
  //   this.channel.bind(
  //     "booking-cancel-customer",
  //     this.handleCustomerCancel,
  //     this
  //   );
  // }

  // componentWillUnmount() {
  //   if (this.channel) {
  //     this.channel.unbind("booking-create", this.eventHandler);
  //     this.channel.unbind("booking-cancel", this.eventHandler);
  //     this.channel.unbind("enquiries", this.eventHandler);
  //     this.channel.unbind("booking-create-customer", this.eventHandler);
  //     this.channel.unbind("booking-cancel-customer", this.eventHandler);
  //     pusher.unsubscribe("taxida-bookings");
  //   }
  // }

  // handleBookingCreate = (data) => {
  //   localStorage.setItem("bookingData", JSON.stringify(data));
  //   if (window.location.pathname === "/b2btrips") {
  //     // window.location.reload();
  //     this.eventHandler(data, "booking-create");
  //     localStorage.removeItem("bookingData");
  //   } else {
  //     this.eventHandler(data, "booking-create");
  //     localStorage.removeItem("bookingData");
  //   }
  // };

  // handleBookingCancel = (data) => {
  //   localStorage.setItem("bookingCancelData", JSON.stringify(data));
  //   if (window.location.pathname === "/b2btrips") {
  //     // window.location.reload();
  //     this.eventHandler(data, "booking-cancel");
  //     localStorage.removeItem("bookingCancelData");
  //   } else {
  //     this.eventHandler(data, "booking-cancel");
  //     localStorage.removeItem("bookingCancelData");
  //   }
  // };

  // handleBookingEnquiry = (data) => {
  //   localStorage.setItem("bookingEnquiryData", JSON.stringify(data));
  //   if (window.location.pathname === "/trips") {
  //     // window.location.reload();
  //     this.eventHandler(data, "enquiries");
  //     localStorage.removeItem("bookingEnquiryData");
  //   } else {
  //     this.eventHandler(data, "enquiries");
  //     localStorage.removeItem("bookingEnquiryData");
  //   }
  // };
  // handleCustomerCreate = (data) => {
  //   localStorage.setItem("bookingCustomerData", JSON.stringify(data));
  //   if (window.location.pathname === "/trips") {
  //     // window.location.reload();
  //     this.eventHandler(data, "booking-create-customer");
  //     localStorage.removeItem("bookingCustomerData");
  //   } else {
  //     this.eventHandler(data, "booking-create-customer");
  //     localStorage.removeItem("bookingCustomerData");
  //   }
  // };
  // handleCustomerCancel = (data) => {
  //   localStorage.setItem("bookingCustomerCancelData", JSON.stringify(data));
  //   if (window.location.pathname === "/trips") {
  //     // window.location.reload();
  //     this.eventHandler(data, "booking-cancel-customer");
  //     localStorage.removeItem("bookingCustomerCancelData");
  //   } else {
  //     this.eventHandler(data, "booking-cancel-customer");
  //     localStorage.removeItem("bookingCustomerCancelData");
  //   }
  // };
  // eventHandler = (data, eventType) => {
  //   bookingToaster(data, eventType, this.props.history);
  // };

  render() {
    const {
      notificationbar: { notificationvisible: Open },
    } = this.props;
    return (
      <div
        ref={this.setWrapperRef}
        className={Open ? "sidebar-R" : "sidebar-R open"}
      ></div>
    );
  }
}
export default connect((state) => {
  return {
    notificationbar: state.notificationbar,
  };
})(NotificationBar);
